<template>
    <div id="editor">
        <div>
            <span>
                <tool-bar class="tool-bar">
                    <head-drop-list></head-drop-list>
                    <pencil-drop-list></pencil-drop-list>

                </tool-bar>
                <!--                <button class="butcss2">编辑</button>-->
                <!--                <button class="butcss2">night</button>-->
                <!--                <button class="butcss2" @click="freshindex">Code</button>-->
                <!--                <button class="butcss2">时间</button>-->
                <!--                <button class="butcss2">加粗</button>-->
                <!--                <button class="butcss2">标题</button>-->
                <!--                <button class="butcss2">链接</button>-->
                <!--                <button class="butcss2">图片</button>-->
                <!--                <input type="text" name="" id="height" placeholder="height" style="width: 40px">-->
                <!--                <input type="text" name="" id="width" placeholder=" width" style="width: 40px">-->
            </span>
            <div class="fixed"></div>
            <div ref="code" v-on:keyup.enter="keyFunction"  contenteditable="true" id="code" class="line"></div>
        </div>

    </div>
</template>

<script>
    import ToolBar from "./childComps/ToolBar";
    import HeadDropList from "./childComps/menu/HeadDropList";
    import PencilDropList from "./childComps/menu/PencilDropList";
    export default {
        name: "Editor",
        components: {HeadDropList, ToolBar, PencilDropList},
        data(){
            return{
                url:'./2020330.html',
                len,
                code:{},
                body,
                div_s,
                num:0,
                state:true,
                isnight:false,
            }
        },
        mounted() {
            this.code=this.$refs.code;
            this.code.focus();
            this.endcursor(this.code);
            this.setindex(1);
        },
        methods:{
            keyFunction(event){
                event=event||window.event;

                this.freshindex();




            },
            freshindex(){
                // 定时器
                // setTimeout(function(){
                // 获取code节点
                // code = document.getElementById("code");
                // 获取code子div集合
                this.div_s = this.code.getElementsByTagName("div");
                // 获取集合长度
                this.len=this.div_s.length;
                // alert(this.len)
                // 定义新索引变量
                let newindex;
                for(let ii = 0; ii<this.len; ii++) {
                    // alert("num:" + ii)
                    let el1=document.createElement("indexin");
                    el1.className="indexnum";
                    el1.contentEditable="false";
                    el1.innerHTML = (ii+(2));
                    let el=document.createElement("index");
                    el.className="indexfirst";
                    el.contentEditable="false";
                    // el.innerHTML = (ii+(2));
                    el.appendChild(el1);
                    // alert(this.div_s[ii].getElementsByTagName('index').html)
                    let hei=this.div_s[ii].getElementsByTagName('index');
                    if (hei.length==0){
                        newindex=el;
                        this.div_s[ii].insertBefore(el,this.div_s[ii].childNodes[0]);
                    }else{
                        this.div_s[ii].replaceChild(el,this.div_s[ii].childNodes[0]);
                    }
                    if(ii % 2==0)
                    {
                        this.div_s[ii].className="line2";
                    }else
                    {
                        this.div_s[ii].className="line1";
                    }
                    // classify(i,div_s[i]);
                    // div_s[i].classList.add("edit");
                    // setid('.edit','code',2);


                }
                if (window.getSelection) {
                    let sel = window.getSelection();
                    if (sel.getRangeAt && sel.rangeCount) {
                        let range = sel.getRangeAt(0);
                        range.setStartAfter(newindex);
                        range=range.collapse(false);
                        let range1 = range.cloneRange();
                        sel.removeAllRanges();
                        // range = document.createRange();
                        sel.addRange(range1);
                    }
                }

            },
            endcursor(code){
                // 新建一个range（连续范围内的文档片段）对象
                let range = document.createRange();
                // selectNodeContents() 方法把范围边界设置为一个节点的子节点
                range.selectNodeContents(code);
                // 把左边界移到右边界重合
                range.collapse(false);
                // 得到选择器对象、可以把光标视为左右边界重合的选择器
                let sel = window.getSelection();
                // 移除所有文档片段range
                sel.removeAllRanges();
                // 添加上面定好位的文档片段range,选择器的范围由其包含的range的范围决定
                // 按住CTRL键加鼠标可以选择多个不连续的rang文档片段对象
                sel.addRange(range);
            },


            setindex(index){
                let el1=document.createElement("indexin");
                el1.className="indexnum";
                el1.contentEditable="false";
                el1.innerHTML = index;

                var el=document.createElement("index");
                el.className="indexfirst";
                el.contentEditable="false";
                el.appendChild(el1);
                if (window.getSelection) {
                    let sel = window.getSelection();
                    if (sel.getRangeAt && sel.rangeCount) {
                        let range = sel.getRangeAt(0);
                        range.deleteContents();

                        let frag = document.createDocumentFragment(),lastNode;
                        lastNode=frag.appendChild(el);
                        range.insertNode(frag);
                        range.setStartAfter(lastNode);
                        range=range.collapse(false);
                        let range1 = range.cloneRange();
                        sel.removeAllRanges();
                        sel.addRange(range1);
                    }
                }

            },
        }
    }
</script>
<style scoped>
    #editor{
        top: 35px;
        position: relative;
    }
    .tool-bar{
        top: 69px;
        display: flex;
        position: fixed;
        width: 100%;
        z-index: 999;
    }
    #code{
        width: 100%;
        white-space: nowrap;
        overflow: auto;
        text-align: left;
        /*position: absolute;*/
        /*background-color: black ;*/
    }
    .line:focus{
        border: none;
        outline: none;
    }
    .fixed{
        height: 1px;
    }
    .line:focus{
        border: none;
        outline: none;
    }
    .butcss2{
        color: #B0B0B0;
        background-color: black;
        border: none;
        margin-left: 10px;
    }
    .butcss2:hover{
        background-color: #449D44;
    }
</style>
<style>
    .indexnum{
        width: 35px;
        border-right: solid;
        padding-right: 5px;
        right: 5px;
        height: 100%;
        font-size: 18px;
        position: relative;
        border-color: rgb(108,226,108);
        /*display: inline-block;*/
        /*background-color: #6ce26c;*/
    }
    .indexfirst{
        text-align: right;
        width: 42px;
        /*border-right: solid;*/
        border-color: rgb(108,226,108);
        height: 100%;
        /*margin-right: 20px;*/
        /*padding-left: auto;*/
        text-align: right;
        font-size: 18px;
        resize: none;
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
        table-layout:fixed ;
        display: inline-block;
        /*left: 0px;*/
        position: relative;
        /*    !*background-color: blue;*!*/
    }

    .line1{
        background-color: rgb(255,255,255);
        /*width: 100% !important;*/
    }
    .line2{

        background-color: rgb(244, 244, 244);
        /*width: 100% !important;*/
    }

    /*.edit{*/
    /*    !*position: relative;*!*/
    /*    !*overflow: auto ;*!*/
    /*    !*width: 100% !important;*!*/
    /*}*/

</style>